












































































































import Vue from 'vue'
import SectionBase from '@/mixins/SectionBase'
import OrderSectionBase from './OrderSectionBase'

export default Vue.extend({
  mixins: [SectionBase, OrderSectionBase],
  computed: {
    showLevelGlued(): boolean {
      const self = this as any;
      return self.show('cooktop_level_glued')
    },
  },
})
